import React from "react";
import Modal from "@mui/material/Modal";
import { Box, Button, Typography } from "@mui/material";
import { Stack, styled } from "@mui/system";
import Boxs from "../../assets/images/calender/box.svg";
import Delete from "../../assets/images/calender/delete.svg";
import Notes from "../../assets/images/calender/notes.svg";
import Calendars from "../../assets/images/calender/calendar.svg";
import Account from "../../assets/images/calender/account.svg";
import { updateLeave } from "../../apiservices/calendar";
import { toast } from "react-toastify";
import moment from "moment";
window.Buffer = window.Buffer || require("buffer").Buffer;
const LeaveModel = ({ popup, closeTaskPopup, events, getLeaves }) => {
  let start = moment(events.extendedProps.leaveDate, "YYYY-MM-DD").format(
    "DD-MM-YYYY"
  );
  let end = moment(events.extendedProps?.leaveEndDate, "YYYY-MM-DD").format(
    "DD-MM-YYYY"
  );
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#FFFFFF",
    boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
    p: 1,
  };
  const Decline = styled(Button)({
    height: "30px",
    width: "95px",
    borderRadius: "4px",
    padding: "8px 30px 8px 30px",
    border: "1px solid #C02727",
    color: "#C02727",
    textTransform: "capitalize",
    "&:hover": {
      boxShadow: "0px 2px 8px 0px #000000",
      background: "#C02727",
      color: "#FFFFFF",
    },
    "&:active": {
      background: "#931D1D",
    },
  });
  const Accept = styled(Button)({
    height: "30px",
    width: "95px",
    borderRadius: "4px",
    padding: "8px 30px 8px 30px",
    border: "1px solid #1B8C87",
    color: "#1B8C87",
    textTransform: "capitalize",
    "&:hover": {
      boxShadow: "0px 2px 8px 0px #000000",
      background: "#1B8C87",
      color: "#FFFFFF",
    },
    "&:active": {
      background: "#146E6A",
    },
  });
  const LeaveDetail = styled(Stack)({
    // height: "15px",
    width: "450px",
  });
  const declineLeave = async (events) => {
    let data = {
      _id: events.extendedProps.aId,
      _rev: events.extendedProps.rev,
      status: "rejected",
    };
    await updateLeave(data);
    getLeaves();
    closeTaskPopup("leaveModal");

    toast.error("Leave Declined");
  };
  const acceptLeave = async (events) => {
    let data = {
      _id: events.extendedProps.aId,
      _rev: events.extendedProps.rev,
      status: "accepted",
    };
    await updateLeave(data);
    getLeaves();

    closeTaskPopup("leaveModal");
    toast.success("Leave Accepted");
  };
  return (
    <div>
      <Modal
        open={popup}
        onClose={() => closeTaskPopup("leaveModal")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <LeaveDetail>
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mb: 3, mx: 1 }}>
              <Stack>
                <Typography variant="h6">
                  <img src={Boxs} alt="" style={{ marginRight: "10px" }} />
                  {events.title}
                </Typography>
                <Typography variant="p" sx={{ mx: 3, color: "#67748E" }}>
                  {start}
                  {!events.extendedProps.startT && " To"}
                  <br />

                  {events.extendedProps.startT
                    ? events.extendedProps.startT + "-"
                    : end}
                  {events.extendedProps?.endT}
                </Typography>
              </Stack>
              <Typography>
                <img src={Delete} alt="" style={{ marginRight: "10px" }} />
                Added:{events.extendedProps.created}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ mb: 2, mx: 1 }}>
              <img src={Notes} alt="" style={{ marginRight: "10px" }} />
              <Typography
                sx={{
                  fontSize: "14px",
                  lineBreak: "anywhere",
                }}>
                {events.extendedProps.description}
              </Typography>
            </Stack>
            {events.extendedProps?.attachment && (
              <Stack alignItems="center" sx={{ mb: 1 }}>
                <a
                  href={events.extendedProps.attachment}
                  target="_blank"
                  rel="noreferrer">
                  view attachment
                </a>
              </Stack>
            )}
            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mx: 1 }}>
              <Typography sx={{ color: "#67748E" }}>
                {" "}
                <img src={Calendars} alt="" style={{ marginRight: "10px" }} />
                {events.extendedProps.applicantName}
              </Typography>
              <Typography
                sx={{
                  color:
                    events.extendedProps.status === "pending"
                      ? "#CAA629"
                      : events.extendedProps.status === "accepted"
                      ? "#2CCA29"
                      : "#CA2929",
                }}
                variant="h6">
                {" "}
                <img
                  src={Account}
                  alt=""
                  style={{ marginRight: "10px" }}
                  height="15px"
                />
                <span
                  style={{
                    color: "#04B2AE",
                  }}>
                  Admin:
                </span>
                {events.extendedProps.status}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              justifyContent="center"
              sx={{ mt: 3, mb: 2 }}>
              <Decline sx={{ mx: 1 }} onClick={() => declineLeave(events)}>
                Decline
              </Decline>
              <Accept onClick={() => acceptLeave(events)}>Accept</Accept>
            </Stack>
          </LeaveDetail>
        </Box>
      </Modal>
    </div>
  );
};

export default LeaveModel;
